// import "./App.css";
import { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import { HomePage } from "./components/homePage";
import Tournaments from "./pages/play/tournaments";
import Seasons from "./pages/play/seasons";
import Summon from "./pages/play/summon";
import BloodQueenSacrifice from "./pages/play/bloodQueenSacrifice";
import BloodQueenGift from "./pages/play/bloodQueenGift";
import LeaderBoards from "./pages/play/leaderBoards";

// classic
import TheDeath from "./pages/classic/theDeath";
import LeaderBoardClassic from "./pages/classic/leaderBoard";

// champions
import Introduction from "./pages/champions/introduction";
import SearchChampions from "./pages/champions/searchChampions";
import SearchBarracks from "./pages/champions/searchBarracks";

// Learn
import RoadMap from "./pages/learn/roadMap";

import Footer from "./components/footer";
import Loader from "./components/Loader";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay (e.g., 2 seconds) to mimic the website loading process.
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  return (
    <div className="App">
      {loading ? (
        <Loader />
      ) : (
        <>
          <Navbar />
          {/* <HomePage /> */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tournaments" element={<Tournaments />} />
            <Route path="/seasons" element={<Seasons />} />
            <Route path="/summon" element={<Summon />} />
            <Route
              path="/blood-queen-sacrifice"
              element={<BloodQueenSacrifice />}
            />
            <Route path="/blood-queen-gift" element={<BloodQueenGift />} />
            <Route path="/leaderboards" element={<LeaderBoards />} />
            <Route path="/death" element={<TheDeath />} />
            <Route
              path="/leaderboard-classic"
              element={<LeaderBoardClassic />}
            />
            <Route path="/introduction" element={<Introduction />} />
            <Route path="/champions" element={<SearchChampions />} />
            <Route path="/barracks" element={<SearchBarracks />} />
            {/* <Route path="/" element={<HomePage />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/" element={<HomePage />} /> */}

            <Route path="/roadmap" element={<RoadMap />} />
          </Routes>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
